import { computed, inject, linkedSignal, resource, signal } from '@angular/core';
import { AgendaRepository } from '../repositories/agenda.repository';

export class AgendaService {
  private agendaRepository = inject(AgendaRepository);
  readonly #agendaResource = resource({
    params: () => ({ mechanicId: this.#mechanicId(), date: this.#date() }),
    loader: async ({ params }) => {
      const mechanicId = params.mechanicId;
      const date = params.date;
      if (!mechanicId || !date) {
        return [];
      }
      const departmentHeads = await this.agendaRepository.getDepartmentHead(date);
      const headId = departmentHeads[0]?.employee?.id;
      if (headId == null) {
        this.#agenda.set([]);
        return [];
      }
      const request = await this.agendaRepository.retrieve(
        String(headId),
        mechanicId,
        date
      );
      this.#agenda.set(request);
      return request;
    },
  });

  readonly #mechanicId = signal<string | null>(null);
  readonly #date = signal<string | null>(null);
  readonly #agenda = signal<any[]>([]);

  readonly agendaLoading = computed(() => this.#agendaResource.isLoading());
  readonly agendaError = computed(() => this.#agendaResource.error());

  readonly agenda = linkedSignal(() => this.#agenda());

  reload(): void {
    this.#agendaResource.reload();
  }

  setMechanicId(mechanicId: string | null) {
    this.#mechanicId.set(mechanicId);
  }

  setDate(date: string | null) {
    this.#date.set(date);
  }
}
